import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { FacilityCategoryChoice, getFacilityCategoryName } from "utils/common";
import { API_HOST } from "Constants";

//소방설비 MDB
export default function FireEquipmentMdbComponent() {
  const [isDelModalOpen, setIsDelModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isListOpen, setIsListOpen] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [formData, setFormData] = useState(null);
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    setFormDataProperty("name", "");
    setFormDataProperty("category", "1");
    setFormDataProperty("iconImageSrc", "");
    setFormDataProperty("iconImageFile", null);

    getData();
  }, []);

  const getData = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.getFireFightingMdbList();
      if (status === true) {
        setDataSource(data);
      } else {
        alert(`${data}`);
      }
    });
  }

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    if (e.target.type === 'file') {
      const files = e.target.files;
      if (files.length > 0) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const iconImage = e.target.result;
          setFormDataProperty("iconImageSrc", iconImage);
          setFormDataProperty("iconImageFile", files[0]);
        };
        reader.readAsDataURL(files[0]);
      }
    } else {
      let name = e.target.name;
      let value = e.target.value;
      setFormDataProperty(name, value);
    }
  };

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedIds(dataSource.map((a) => a.id));
    } else {
      setCheckedIds([]);
    }
  };

  const handleChangeCheck = (e, id) => {
    if (e.target.checked) {
      setCheckedIds([...checkedIds, id]);
    } else {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    }
  };

  const openModal = () => {
    setFormDataProperty("name", "");
    setFormDataProperty("category", "1");
    setFormDataProperty("iconImageSrc", "");
    setFormDataProperty("iconImageFile", null);

    setIsModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  }

  const closeModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsModalOpen(false);
    }, 500);
  }

  const handleDelete = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.bulkDeleteFireFightingMdb(checkedIds);
      alert(`${data}`)

      //삭제 성공 시 새로고침
      if (status === true) {
        getData();
        closeDelModal();
      }
    });
  }

  const openDelModal = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      setIsDelModalOpen(true);
    }
  }

  const closeDelModal = () => {
    setIsDelModalOpen(false);
  }

  const toggleSelectBox = () => {
    setIsListOpen(!isListOpen);
  };

  const handleItemClick = (item) => {
    setFormDataProperty("category", item);
    setIsListOpen(false);
  };

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        requestBody.append("iconImage", formData.iconImageFile);
        requestBody.append("payload",
          JSON.stringify({
            name: formData.name,
            category: formData.category,
          }));

        const { status, data } = await dbmsApi.addFireFightingMdb(requestBody);
        if (status === true) {
          alert(`저장을 완료하였습니다.`);
          //성공 시 새로고침
          closeModal();
          getData();
        } else {
          alert(`저장을 실패하였습니다.\n${data}`)
        }
      });
    }
  }

  const checkValid = () => {
    if (formData.iconImageFile === null) {
      alert(`아이콘 이미지를 선택해주세요.`);
      return false;
    }
    return true;
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard">
        <div class="top_board pc">
          <p class="title_board">소방설비 MDB</p>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                {/* <img src="/images/my_btn_mb.png" alt=""> */}
              </Link>
            </div>
          </div>
        </div>

        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">소방설비 MDB</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board ">
          <p class="table_mb_title mb">소방설비 범례</p>
          <table class="admin-table feMDB-table">
            <colgroup>
              <col width="10%" />
              <col width="12%" />
              <col width="25%" />
              <col width="45%" />
            </colgroup>
            <thead class="admin-thead">
              <tr class="admin-tr">
                <th class="admin-th">
                  <input type="checkbox" name="" id="" onChange={handleCheckAll} />
                </th>
                <th class="admin-th">
                  <p>아이콘</p>
                </th>
                <th class="admin-th">
                  <p>분류</p>
                </th>
                <th class="admin-th">
                  <p>설비명</p>
                </th>
              </tr>
            </thead>
            <tbody class="admin-tbody">
              {dataSource &&
                dataSource.map((item, index) => (
                  <tr class="admin-tr">
                    <td class="admin-td">
                      <input type="checkbox" name="" id="" checked={checkedIds.includes(item.id)} onChange={(e) => handleChangeCheck(e, item.id)} />
                    </td>
                    <td class="admin-td">
                      <div class="icon_mdb">
                        <img src={API_HOST + item.iconImage} alt="" />
                      </div>
                    </td>
                    <td class="admin-td">
                      {getFacilityCategoryName(item.category)}
                    </td>
                    <td class="admin-td">
                      {item.name}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div class="wrap_controll dark">
          <div class="wrap_dbms_btn">
            <button class="item_btn add_btn" onClick={openModal}>추가</button>
            <button class="item_btn" id="deleteBtn" onClick={openDelModal}>삭제</button>
          </div>
        </div>

        {/* <!-- 삭제 여부 모달 --> */}
        {isDelModalOpen && (
          <div id="modal" class="modal dbmsDelModal show">
            <div class="modal-content">
              <div class="modal_inner">
                <p class="modal_title">정말로 삭제하시겠습니까?</p>
                <p class="modal_sub">삭제하시면 선택하신 정보는 사라집니다.</p>
                <div class="btn-wrap">
                  <button class="modal_btn" onClick={closeDelModal}>취소</button>
                  <button class="modal_btn del_btn" onClick={handleDelete}>삭제</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {isModalOpen && (
          <div id="modal" class="modal rightModal noticeRightModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeModal();
            }}>
            <form class="modal_content" onSubmit={handleSave}>
              <button type="button" class="close_modal" onClick={closeModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>소방설비MDB 정보</h2>
              {formData && (
                <div class="wrap_detail_cont type2">
                  <div class="wrap_detail_item default_type_item">
                    <p class="title_detail">설비명</p>
                    <div class="detail_box">
                      <input class="default_input" type="text" placeholder="설비명을 입력해주세요." name="name" value={formData.name} onChange={onChange} required />
                    </div>
                  </div>
                  <div class="wrap_detail_item">
                    <p class="title_detail">설비분류</p>
                    <div class="detail_box wrap_search">
                      <div className={`select_box ${isListOpen ? "open" : ""}`}>
                        <button type="button" class="btn_select" onClick={toggleSelectBox}>
                          <p>{getFacilityCategoryName(formData.category)}</p>
                          <i class="x-icon"></i>
                        </button>
                        <ul class="list_member">
                          {Object.values(FacilityCategoryChoice).map(
                            (item, index) => (
                              <li name="classification" onClick={() => handleItemClick(item)}>
                                <p>{getFacilityCategoryName(item)}</p>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="wrap_detail_item default_type_item icon_add_box">
                    <p class="title_detail">아이콘</p>
                    <div class="detail_box">
                      <label for="file-upload" class="file-upload-btn">+</label>
                      <input type="file" accept=".png, .jpg, .jpeg" id="file-upload" class="file-upload-input" name="iconImage" onChange={onChange} />
                      {formData.iconImageFile && (
                        <div class="new-icon-wrap">
                          <div class="icon-item">
                            <img src={formData.iconImageSrc} alt="" />
                          </div>
                        </div>
                      )}
                    </div>
                    <p class="icon-description"><i class="x-icon"></i>아이콘은 하나만 등록 가능하며 검은 배경에서 잘 보일 수 있도록 흰색 아이콘을 사용해주세요.</p>
                  </div>
                  <button type="submit" class="btn_dark">저장</button>
                </div>
              )}
            </form>
          </div >
        )
        }

      </div >
    </>
  );
}
